import React from "react";
//import { setUserState } from "../actions/ListaDeUsuarios";


const Mensaje = () => {

    return (
        <ul className="dropdown-menu">
            <li>
                <p>Debe seleccionar usuarios con el mismo estado</p>
            </li>
        </ul>
        
    );


}

const BotonDesBloqueo = (props) => {

    let usuariosSeleccionados = props.usuariosFiltrados.filter(x => x.Seleccionado == true).length;
    let DesBloqueados = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Bloqueado == false).length;
    return (
        <div className="dropdown">
            <button className="btn btn-icon btn-blocked" title="Desbloquear los seleccionados" data-toggle="dropdown"
                disabled={!(usuariosSeleccionados > 0)}
                onClick={(DesBloqueados >= 1) ? null : () => props.setUserState(null, true, false) }>
                <span className="ti-unlock"></span>
            </button>
            {(DesBloqueados >= 1) ? <Mensaje /> : null}
        </div>
        
      );
}


export default BotonDesBloqueo;